var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H21",
    stroke: "#3CBD96",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.81818H21M19 3V7",
    stroke: "#3CBD96",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5L7.5 0.5L14 3.5M1 3.5V10.5L7.5 13.5M1 3.5L7.5 7M14 3.5V10L7.5 13.5M14 3.5L7.5 7M7.5 13.5V7",
    stroke: "#3CBD96",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.4fc59bfda6999e63e9ff8267071496df.svg";
export { ForwardRef as ReactComponent };